module.exports = __webpack_public_path__ + "static/img/5.1046a8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/04/1/5.png
// module id = vhmv
// module chunks = 2